<template>
    <div>
        <treeselect
            valueFormat="object"
            v-model="currentSelected"
            :multiple="true"
            :async="false"
            :options="currentOptions"
            :clear-on-select="true"
            ref="select"

            :placeholder="currentLang.placeholder"
            :retryTitle="currentLang.retryTitle"
            :retryText="currentLang.retryText"
            :noOptionsText="currentLang.noOptionsText"
            :noResultsText="currentLang.noResultsText"
            :noChildrenText="currentLang.noChildrenText"
            :searchPromptText="currentLang.searchPromptText"
            :clearValueText="currentLang.clearValueText"
            :clearAllText="currentLang.clearAllText"
        ></treeselect>

        <input type="hidden" :name="this.getName()" v-model="encodedData">
    </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'

import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
    components: {
        Treeselect
    },
    props: {
        selected: {
            required: false,
            type: Array
        },
        options: {
            required: true,
            type: Array
        },
        property: {
            required: true
        }
    },
    data () {
        return {
            currentLang: {
                'placeholder': 'Select...',
                'retryTitle': 'Click to retry',
                'retryText': 'Retry?',
                'noOptionsText': 'No options available.',
                'noResultsText': 'No results found...',
                'noChildrenText': 'No sub-options.',
                'searchPromptText': 'Type to search...',
                'clearValueText': 'Clear value',
                'clearAllText': 'Clear all'
            },
            currentSelected: null,
            currentOptions: []
        }
    },
    computed: {
        encodedData() {
            return JSON.stringify(this.currentSelected);
        }
    },
    methods: {
        getName() {
            return "properties[" + this.property + "][options]";
        }

    },
    mounted () {
        this.currentSelected = this.selected.map(i => ({
            id: `${i.id}`,
            label: `${i.label}`
        }));

        this.currentOptions = this.options.map(i => ({
            id: `${i.id}`,
            label: `${i.label}`
        }));
    }
}
</script>

<style scoped>

</style>
